import type { TcMode } from '../../api/types';

/** Minutes -> « 5 h 00 » ou « 45 min ». */
export function formatDuration(minutes: number): string {
  if (minutes < 60) return `${minutes} min`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m === 0 ? `${h} h` : `${h} h ${String(m).padStart(2, '0')}`;
}

/** Minutes depuis minuit -> « 08:30 ». Null -> « — ». */
export function formatTimeOfDay(minutes: number | null): string {
  if (minutes == null) return '—';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

/** « 08:30 » -> minutes depuis minuit. Chaine vide -> null. */
export function parseTimeOfDay(value: string): number | null {
  if (!value) return null;
  const [h, m] = value.split(':').map(Number);
  return h * 60 + (m || 0);
}

export const TC_MODE_LABEL: Record<TcMode, string> = {
  SANS_TC: 'Sans Tc',
  TC_PAR_PIECE: 'Tc par piece',
  PLAN_DE_CHARGEMENT: 'Plan de chargement',
};

/** Un cycle est « pilote par les Tc » quand ses durees mini et maxi different. */
export function isTcDriven(minDurationMinutes: number, maxDurationMinutes: number): boolean {
  return maxDurationMinutes > minDurationMinutes;
}
